import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "nav_left",
  "use": "nav_left-usage",
  "viewBox": "0 0 8 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 10\" id=\"nav_left\"><path d=\"M4.17 8.67 2.34 5l1.83-3.67a.742.742 0 0 0-.33-1 .745.745 0 0 0-1.01.34L.66 5l2.17 4.33c.19.37.64.52 1.01.34s.52-.63.33-1m1.66-8L3.66 5l2.17 4.33c.19.37.64.52 1.01.34.37-.19.52-.64.34-1.01L5.34 5l1.83-3.67a.742.742 0 0 0-.33-1 .74.74 0 0 0-1.01.34\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol